export { default } from "./Thumbnails.jsx"
